import styled from 'styled-components';

import { BodyRegularMedium, BodySmall } from '@src/fonts/typography/Typography';

export const ProductContainer = styled.li<{ $isCompleted: boolean; $isSelected: boolean }>`
  display: flex;
  flex-direction: column;

  border-radius: 1rem;
  border: 1px solid #bbb;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  background-color: ${(props) => {
    if (props['aria-disabled']) return '#E8E8E8';

    if (props.$isSelected || props.$isCompleted) {
      return '#E1F2FF';
    }

    return '#fff';
  }};

  opacity: ${(props) => (props['aria-disabled'] ? 0.7 : 1)};
  pointer-events: ${(props) => (props['aria-disabled'] || props.$isCompleted || props.$isSelected ? 'none' : 'auto')};

  &:last-of-type {
    margin-bottom: 4px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 97px;
  overflow: hidden;

  border-start-end-radius: 1rem;
  border-start-start-radius: 1rem;

  border-bottom: 1px solid #bbb;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProductContentArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;

  .MuiScopedCssBaseline-root {
    background: inherit;
  }
`;

export const ProductName = styled.p`
  ${BodyRegularMedium};
  font-weight: 600;
  color: #464646;

  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: space-between;
`;

export const ProductSelectionInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;

  color: #464646;

  p,
  sgv {
    color: inherit;
  }
`;

export const SelectionInfo = styled.p`
  ${BodySmall};
  color: inherit;
`;

export const ProductNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

export const TariffContainer = styled.p`
  ${BodySmall};
  color: inherit;

  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const ProductProviderName = styled.p`
  ${BodySmall};
  color: #464646;
  font-weight: 400;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: -0.25rem;
`;
